import script from "./order-apply.vue?vue&type=script&lang=ts&setup=true"
export * from "./order-apply.vue?vue&type=script&lang=ts&setup=true"

import "./order-apply.vue?vue&type=style&index=0&id=6543ce07&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6543ce07"]])

export default __exports__